import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageCopyDirectoryError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageCopyDirectoryError'),
  sourceKey: z.string(),
  destinationKey: z.string(),
});

export type S3StorageCopyDirectoryError = z.infer<
  typeof S3StorageCopyDirectoryError
>;
